import React from "react";
import "../styles/ConvertProgress.css";

/* ─── Icons ─── */
const LayoutIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" /><line x1="3" y1="9" x2="21" y2="9" /><line x1="9" y1="21" x2="9" y2="9" />
  </svg>
);
const RepeatIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="17 1 21 5 17 9" /><path d="M3 11V9a4 4 0 0 1 4-4h14" />
    <polyline points="7 23 3 19 7 15" /><path d="M21 13v2a4 4 0 0 1-4 4H3" />
  </svg>
);
const CreditCardIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="1" y="4" width="22" height="16" rx="2" /><line x1="1" y1="10" x2="23" y2="10" />
  </svg>
);
const SettingsIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);
const HelpIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10" /><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" /><line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const BackIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="19" y1="12" x2="5" y2="12" /><polyline points="12 19 5 12 12 5" />
  </svg>
);
const CheckCircle = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#10B981" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" /><polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);
const SpinnerIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="pg-spinner">
    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
  </svg>
);
const DownloadIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="7 10 12 15 17 10" /><line x1="12" y1="15" x2="12" y2="3" />
  </svg>
);

/* ─── Data ─── */
const NAV_ITEMS = [
  { label: "Dashboard", icon: <LayoutIcon />, active: false },
  { label: "Conversions", icon: <RepeatIcon />, active: true },
  { label: "Payments", icon: <CreditCardIcon />, active: false },
  { label: "Settings", icon: <SettingsIcon />, active: false },
  { label: "Help", icon: <HelpIcon />, active: false },
];

const FILES = [
  { name: "annual_report_2025.pdf", format: "PDF → DOCX", detail: "14.2 MB processed in 28s", status: "completed", color: "#EF4444" },
  { name: "product_photos_batch.zip", format: "ZIP → PNG", detail: "45.8 MB processed in 1m 12s", status: "completed", color: "#8B5CF6" },
  { name: "quarterly_metrics.xlsx", format: "XLSX → CSV", detail: "Processing assets...", status: "processing", progress: 70, color: "#10B981" },
];

const JOB_DETAILS = [
  { label: "JOB ID", value: "CVT-2026-48291" },
  { label: "STARTED AT", value: "Jan 28, 2026 at 2:34 PM" },
  { label: "CONVERSION QUALITY", value: "High Quality (Lossless)" },
  { label: "QUEUE PRIORITY", value: "Standard Queue" },
  { label: "EMAIL NOTIFICATION", value: "Enabled (alex@convertpro.com)" },
  { label: "AUTO-DOWNLOAD", value: "Disabled" },
];

/* ─── Sidebar ─── */
function Sidebar() {
  return (
    <aside className="pg-sidebar">
      <div className="pg-sidebar-upper">
        <div className="pg-profile">
          <div className="pg-avatar" />
          <div className="pg-profile-info">
            <span className="pg-profile-name">ConvertPro</span>
            <span className="pg-profile-role">Alex Sterling • Admin</span>
          </div>
        </div>
        <nav className="pg-nav">
          {NAV_ITEMS.map((item) => (
            <a key={item.label} href={`#${item.label.toLowerCase()}`}
               className={`pg-nav-item ${item.active ? "pg-nav-item--active" : ""}`}>
              <span className="pg-nav-icon">{item.icon}</span>
              {item.label}
            </a>
          ))}
        </nav>
      </div>
      <div className="pg-plan-badge">
        <div className="pg-plan-badge-header">
          <span className="pg-plan-tier">ENTERPRISE TIER</span>
          <span className="pg-plan-dot" />
        </div>
        <span className="pg-plan-name">Pro Plan Active</span>
        <span className="pg-plan-renew">Auto-renews Feb 28, 2026</span>
      </div>
    </aside>
  );
}

/* ─── Main ─── */
function MainContent() {
  const completed = FILES.filter((f) => f.status === "completed").length;
  const total = FILES.length;
  const overallPercent = Math.round((completed / total) * 100);

  return (
    <main className="pg-main">
      {/* Header */}
      <div>
        <a href="#conversions" className="pg-back-link"><BackIcon /> Back to Conversions</a>
        <h1 className="pg-page-title">Conversion in Progress</h1>
        <p className="pg-page-sub">Your files are being processed securely. You will be notified when complete.</p>
      </div>

      {/* Overall Progress */}
      <div className="pg-card pg-progress-card">
        <div className="pg-progress-header">
          <div className="pg-progress-info">
            <CheckCircle />
            <div>
              <span className="pg-progress-title">{completed} of {total} files completed</span>
              <span className="pg-progress-time">~45 seconds remaining</span>
            </div>
          </div>
          <span className="pg-progress-pct">{overallPercent}% Done</span>
        </div>
        <div className="pg-progress-track">
          <div className="pg-progress-fill" style={{ width: `${overallPercent}%` }} />
        </div>
      </div>

      {/* File List */}
      <div className="pg-card">
        {FILES.map((file, i) => (
          <React.Fragment key={i}>
            <div className="pg-file-row">
              <div className="pg-file-info">
                <div className="pg-file-icon" style={{ background: file.color }}>{file.name[0].toUpperCase()}</div>
                <div className="pg-file-details">
                  <span className="pg-file-name">{file.name}</span>
                  <span className="pg-file-meta">{file.format} · {file.detail}</span>
                  {file.status === "processing" && (
                    <div className="pg-file-progress-track">
                      <div className="pg-file-progress-fill pg-file-progress-fill--amber" style={{ width: `${file.progress}%` }} />
                    </div>
                  )}
                </div>
              </div>
              <div className="pg-file-actions">
                {file.status === "completed" ? (
                  <>
                    <span className="pg-status-completed">Completed</span>
                    <button className="pg-download-link">Download</button>
                  </>
                ) : (
                  <>
                    <SpinnerIcon />
                    <span className="pg-status-processing">Processing...</span>
                    <span className="pg-file-pct">{file.progress}%</span>
                  </>
                )}
              </div>
            </div>
            {i < FILES.length - 1 && <div className="pg-divider" />}
          </React.Fragment>
        ))}
      </div>

      {/* Job Details */}
      <div className="pg-card">
        <div className="pg-card-header">
          <h4>Conversion Job Details</h4>
          <p>System parameters for job allocation and scheduling</p>
        </div>
        <div className="pg-divider" />
        <div className="pg-details-grid">
          {JOB_DETAILS.map((d) => (
            <div key={d.label} className="pg-detail-item">
              <span className="pg-detail-label">{d.label}</span>
              <span className="pg-detail-value">{d.value}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Action Bar */}
      <div className="pg-action-bar">
        <div className="pg-action-info">
          <SpinnerIcon />
          <span>Processing 1 of 3 remaining...</span>
        </div>
        <div className="pg-action-btns">
          <button className="pg-btn-cancel">Cancel All</button>
          <button className="pg-btn-download" style={{ opacity: 0.6 }} disabled>
            <DownloadIcon /> Download All ({completed}/{total})
          </button>
        </div>
      </div>
    </main>
  );
}

export default function ConvertProProgress() {
  return (
    <div className="pg-layout">
      <Sidebar />
      <MainContent />
    </div>
  );
}
